import { ThemeType } from '@lessonPlanner/constants';

export const THEME_CATEGORIES = {
  scienceAndTech: {
    label: 'Science and Tech',
    themes: [
      ThemeType.LABORATORY,
      ThemeType.SPACE,
      ThemeType.ENERGY,
      ThemeType.CIRCLE_OF_LIFE,
    ],
  },
  humanitiesAndSociety: {
    label: 'Humanities and Society',
    themes: [ThemeType.WATER_COLOR, ThemeType.BRUSH_STROKES],
  },
  professional: {
    label: 'Professional',
    themes: [
      ThemeType.GRADIENT,
      ThemeType.OFFICE,
      ThemeType.CORNER_BENDS,
      ThemeType.EVERGREEN,
    ],
  },
  events: {
    label: 'Events',
    themes: [ThemeType.STATIONERY],
  },
  colors: {
    label: 'Colors',
    themes: [ThemeType.WHITE, ThemeType.BLUE, ThemeType.ORANGE],
  },
};
